<template>
    <div class="page-company">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :span="18">
                    <h2 class="m-b-0">{{companyName}}</h2>
                </el-col>
                <el-col :span="6" align="right">
                    <el-button
                            class="font-weight-bold"
                            @click="$router.push({ name: 'company' })"
                            icon="icon-rotate-ccw"
                    >
                        К списку компаний
                    </el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12" class="m-b-20 m-b-lg-0">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="name" label="">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{ scope.row.View.DisplayName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="value" label="">
                        <template slot-scope="scope">
                            <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-table v-loading="loadingCustomers" :data="customersTable">
                    <el-table-column prop="Name" label="ФИО">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Name }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="MaxAllowedCards" label="Max Карт" v-if="$mobile()" />
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Input2 from '@/components/Input2'

    export default {
        components: { Input2 },
        data () {
            return {
                itemType: 'Company',
                loading: false,
                loadingCustomers: false,
                total: 0,
                dataTable: [],
                customersTable: [],
                companyId: this.$route.params.id,
                companyName: ''
            }
        },
        created () {
            this.getCustomers()
            this.getData()
        },
        methods: {
            getData () {
                this.loading = true

                let request = {
                    Name: "GetItemView",
                    ItemType: "Company",
                    OperatorName: "Admin",
                    ItemId: this.companyId
                }

                this.$api.Main.getCompany(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Parameters

                    this.dataTable.map(row => {
                        if (row.View.Name === 'Name') this.companyName = row.Value
                    })
                }).catch (() => {
                    this.loading = false
                })
            },
            getCustomers () {
                this.loadingCustomers = true

                let request = {
                    Name: "GetItemsList",
                    ItemType: "Customer"
                }
                request.Filter = {
                    Type: "Simple",
                    Field: "CompanyID",
                    Operation: "Equal",
                    Value: this.companyId
                }

                this.$api.Main.getCustomers(request).then(response => {
                    console.log(response)
                    this.loadingCustomers = false
                    this.customersTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loadingCustomers = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'customerDetails', params: { id: id } })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
